import moment from "moment";
import { IDayRateType, ITimeRateType, ITypeCarType } from "../types";


interface ParcelType {
    amount: number;
}

interface ServiceOption {
    amount: number;
}

interface InstructionData {
    parcelTypeSelected?: ParcelType;
    optionSelected?: ServiceOption;
}

interface FareResult {
    totalCost: number;
    grandTotal: number;
    convenience_fees: number;
}

const getAdditionalFee = (arrayDays?: IDayRateType[], arrayTimes?: ITimeRateType[]): number => {
    if (!arrayDays?.length && !arrayTimes?.length) {
        return 0;
    }

    const currentMoment = moment();
    const currentDate = currentMoment.format('YYYY-MM-DD');
    const currentTime = currentMoment.format('HH:mm:ss');

    const dateRate = arrayDays?.find(rate => rate.day === currentDate);
    if (dateRate) {
        return dateRate.additionalFee;
    }

    const timeRate = arrayTimes?.find(rate => {
        const startTime = moment(rate.initialTime, 'HH:mm:ss');
        const endTime = moment(rate.finalTime, 'HH:mm:ss');
        const checkTime = moment(currentTime, 'HH:mm:ss');
        return checkTime.isBetween(startTime, endTime, null, '[)');
    });

    return timeRate ? timeRate.additionalFee : 0;
};

export const FareCalculator = (
    distance: string | number,
    time: string | number,
    rateDetails: ITypeCarType,
    instructionData?: InstructionData,
    decimal: number = 2
): FareResult => {


    const additionalFeeByDateOrTime = getAdditionalFee(rateDetails.days, rateDetails.times);

    let baseCalculated = (parseFloat(String(rateDetails.rate_per_unit_distance)) * parseFloat(String(distance))) + (parseFloat(String(rateDetails.rate_per_hour) || '0') * (parseFloat(String(time)) / 3600));
   
   
    if (rateDetails.base_fare > 0) {
        baseCalculated += rateDetails.base_fare;
    }
    
    if (instructionData?.parcelTypeSelected) {
        baseCalculated += instructionData.parcelTypeSelected.amount;
    }
    
    if (instructionData?.optionSelected) {
        baseCalculated += instructionData.optionSelected.amount;
    }

    let total = baseCalculated > parseFloat(rateDetails.min_fare.toString()) 
        ? baseCalculated 
        : parseFloat(rateDetails.min_fare.toString());
    
    let convenienceFee: number = 0;
    if (rateDetails.convenience_fee_type === 'flat') {
        convenienceFee = rateDetails.convenience_fees;
    } else {
        convenienceFee = (total * parseFloat(rateDetails.convenience_fees.toString()) / 100);
    }

    let grand = total + convenienceFee;

    let additionalFeeGrandTotalByTime = 0;
    let additionalFeeTotalByTime = 0;

    if (additionalFeeByDateOrTime !== 0 && additionalFeeByDateOrTime > 0) {
        additionalFeeGrandTotalByTime = (additionalFeeByDateOrTime / 100) * grand;
        additionalFeeTotalByTime = (additionalFeeByDateOrTime / 100) * total;
    }

    const grandTotalWithAdditionalFee = grand + additionalFeeGrandTotalByTime;
    const totalCostWithAdditionalFee = total + additionalFeeTotalByTime;

    return {
        totalCost: parseFloat(totalCostWithAdditionalFee.toFixed(decimal)),
        grandTotal: parseFloat(grandTotalWithAdditionalFee.toFixed(decimal)),
        convenience_fees: parseFloat(convenienceFee.toFixed(decimal))
    };
};